<form *ngIf="!success" class="form signup" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div *ngIf="error" class="alert alert-warning">{{error}}</div>

  <form-field class="front" label="Email" i18n-label="@@front.registerMarketer.email.label">
    <input type="email" formControlName="email" placeholder="Enter your email address" i18n-placeholder="@@front.registerMarketer.email.placeholder">
  </form-field>

  <form-field class="front" label="Full Name" i18n-label="@@front.registerMarketer.name.label">
    <input type="text" formControlName="name" placeholder="Enter your full name" i18n-placeholder="@@front.registerMarketer.name.placeholder">
  </form-field>

  <form-field class="front" label="Company (Optional)" i18n-label="@@front.registerMarketer.company.label">
    <input type="text" formControlName="company" placeholder="Enter your company name" i18n-placeholder="@@front.registerMarketer.company.placeholder">
  </form-field>

  <form-field class="front textarea" label="Message" i18n-label="@@front.registerMarketer.message.label">
    <textarea formControlName="message" placeholder="Enter your message" rows="5" i18n-placeholder="@@front.registerMarketer.message.placeholder"></textarea>
  </form-field>

  <button type="submit" class="btn btn-front btn-lg btn-primary d-block w-100" [disabled]="form.invalid || loading">
    <ng-container *ngIf="loading" i18n="@@front.registerMarketer.loadingSubmit">Loading ...</ng-container>
    <ng-container *ngIf="!loading" i18n="@@front.registerMarketer.SubmitButton">Register your Interest</ng-container>
  </button>
</form>

<success *ngIf="success">
  <h3 i18n="@@front.registerMarketer.success.title">Thank you for registering your interest</h3>
  <p i18n="@@front.registerMarketer.success.message">We will be contacting you soon</p>
</success>